module.exports = __webpack_public_path__ + "static/media/touch_here.bca83bd0.gif";